import { render, staticRenderFns } from "./GradingEdit.vue?vue&type=template&id=a7f269bc"
import script from "../../controllers/grading/grading-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/grading/grading-edit.js?vue&type=script&lang=js&external"
import style0 from "./GradingEdit.vue?vue&type=style&index=0&id=a7f269bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports